/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Frequency_DailyInputs */



/**
* | output |
* | --- |
* | "Every day" |
*
* @param {Agent_Schedule_Frequency_DailyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_frequency_daily = /** @type {((inputs?: Agent_Schedule_Frequency_DailyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Frequency_DailyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Täglich")
	return /** @type {LocalizedString} */ ("Every day")
});